import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dartom_token');
    if (token) {
      api.me().then(u => setUser(u)).catch(() => localStorage.removeItem('dartom_token')).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { token, user } = await api.login(email, password);
    localStorage.setItem('dartom_token', token);
    setUser(user);
    return user;
  };

  const register = async (name, email, password, inviteCode) => {
    const { token, user } = await api.register(name, email, password, inviteCode);
    localStorage.setItem('dartom_token', token);
    setUser(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem('dartom_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
